class WholesaleProductItem extends HTMLElement {
  selectedClass = 'collection-product-card__variants-color-selected';

  isMobileDevice() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.innerWidth <= 768
    );
  }

  constructor() {
    super();

    this.initProductSwiper();

    this.mediaList = this.querySelectorAll('.collection-card__media');
    this.variantsOptions = this.querySelectorAll('.collection-product-card__variants-color');
    this.cover = this.querySelector('.collection-card__media-cover');

    if (this.cover && !this.isMobileDevice()) {
      this.cover.addEventListener('mouseenter', this.onCoverMouseEnter.bind(this));
      this.cover.addEventListener('mouseleave', this.onCoverMouseOut.bind(this));
    }

    if (this.variantsOptions) {
      this.variantsOptions.forEach((option) => {
        // option.addEventListener('click', );
        option.addEventListener('mouseenter', this.onVariantClick.bind(this));
      });
    }
  }

  onCoverMouseEnter(event) {
    const front = this.cover.querySelector('.collection-card__media-image');
    const back = this.cover.querySelector('.collection-card__media-image-back');
    if (back.classList.contains('hidden')) {
      back.classList.remove('hidden');
      front.classList.add('hidden');
    }
  }

  onCoverMouseOut(event) {
    const front = this.cover.querySelector('.collection-card__media-image');
    const back = this.cover.querySelector('.collection-card__media-image-back');

    if (front.classList.contains('hidden')) {
      back.classList.add('hidden');
      front.classList.remove('hidden');
    }
  }

  initProductSwiper() {
    const swiperElement = this.querySelector('.collection-product-card__cover-swiper');
    if (!swiperElement) return;

    new Swiper(swiperElement, {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  hiddenAllMedia() {
    if (this.mediaList) {
      this.mediaList.forEach((media) => {
        if (!media.classList.contains('hidden')) {
          media.classList.add('hidden');
        }
      });
    }
  }

  removeAllColorSelected() {
    if (this.variantsOptions) {
      this.variantsOptions.forEach((option) => {
        option.classList.remove(this.selectedClass);
      });
    }
  }

  onVariantClick(event) {
    // const target = event.currentTarget;
    // const targetId = target.dataset.target;

    // if (!targetId) return;

    // this.hiddenAllMedia();
    // this.removeAllColorSelected();

    // const media = this.querySelector(`#${targetId}`);
    // if (media) {
    //   media.classList.remove('hidden');
    //   target.classList.add(this.selectedClass);
    // }
    const targetId = event.target.dataset.target;
    this.hiddenAllMedia();
    if (!this.cover.classList.contains('hidden')) {
      this.cover.classList.add('hidden');
    }

    const elem = this.querySelector(`#${targetId}`);
    if (elem) {
      elem.classList.remove('hidden');
    }

    const variantUrl = elem.dataset.url;

    if (!event.target.classList.contains(this.selectedClass)) {
      this.removeAllColorSelected();
      event.target.classList.add(this.selectedClass);
    }

    // this.querySelector('.collection-product-card__title a').setAttribute('href', variantUrl);
    this.querySelectorAll('a').forEach((item) => {
      if (!item.classList.contains('wholesale-product-card__price-wsp-lock')) {
        item.setAttribute('href', variantUrl);
      }
    });
  }
}

customElements.define('wholesale-product-item', WholesaleProductItem);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-product-card[data-tiered-price]').forEach(function (card) {
    const tieredPriceStr = card.getAttribute('data-tiered-price');
    let minWsqPrice = null;
    try {
      const tiered = JSON.parse(tieredPriceStr);
      if (tiered && Array.isArray(tiered.prices)) {
        tiered.prices.forEach((item) => {
          const price = Number(item.price);
          if (!isNaN(price) && price > 0 && (minWsqPrice === null || price < minWsqPrice)) {
            minWsqPrice = price;
          }
        });
      }
      console.log('minWsqPrice', minWsqPrice);
    } catch (e) {}
    if (minWsqPrice !== null) {
      const wsqNode = card.querySelector('.wholesale-price-area__wsp');
      if (wsqNode) wsqNode.textContent = `$${minWsqPrice}`;
    }
  });
});
